import React, { FC } from 'react';

import { EvIcon, EvincedIcon, EvLink, EvTitle } from '@evinced-private/ui-common';

import {
	DOCUMENTATION_LINKS_MAP,
	MOBILE_SDK_INFO
} from 'src/apps/mobile-sdk/helpers/MobileSdkDashboardHelpers';
import { RoutesHelper } from 'src/common/helpers/RoutesHelper';

import './AnnouncementBanner.scss';

export const AnnouncementBanner: FC = () => {
	return (
		<div className="mobile-sdk-banner-wrapper">
			<EvIcon icon={EvincedIcon} />
			<div className="mobile-sdk-banner-content">
				<EvTitle
					className="mobile-sdk-banner-title"
					titleText="Welcome to the new Evinced Platform — Mobile SDKs"
				/>
				<div className="mobile-sdk-banner-body">
					<div className="mobile-sdk-banner-text">
						Reports are available for the following Mobile SDK versions and newer:
					</div>
					<div className="mobile-sdks-info">
						{MOBILE_SDK_INFO.map(({ label, version }) => (
							<div className="mobile-sdk-banner-tag" key={`${label}-${version}`}>
								<EvLink
									url={DOCUMENTATION_LINKS_MAP[label]}
									ariaLabel={`${label}, version ${version}`}
									customLink={
										<>
											{label} <span className="strong">V {version}</span>
										</>
									}
									className="banner-tag-link"
									openInNewTab
								/>
							</div>
						))}
					</div>
					<div className="mobile-sdk-banner-text">
						To see reports from previous SDK versions, go to the{' '}
						<EvLink url={RoutesHelper.getMobileSdkV1DashboardPath()} linkText="previous platform" />
						.
					</div>
				</div>
			</div>
		</div>
	);
};
